import { Box, Button, Modal, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ViewQueries = () => {
  const navigate = useNavigate();
  const { rfqId } = useParams();
  const { logisticDraftId } = useParams();
  const [queries, setQueries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const location = useLocation();
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (query) => {
    setSelectedQuery(query);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedQuery(null);
    setOpen(false);
  };

  useEffect(() => {
    const getQueries = async () => {
      try {
        if (location.pathname.includes("logistic-dashboard")) {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/query/get-by-rfq?logisticDraftId=${logisticDraftId}&vendorId=${vendorId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setQueries(res.data);
        } else {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/query/get-by-rfq?rfqId=${rfqId}&vendorId=${vendorId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setQueries(res.data);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching queries:", error);
      }
    };
    getQueries();
  }, [rfqId]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const [hours, minutes] = time?.split(":") || [];
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={() => navigate(rfqId ? `/vendor/dashboard/${rfqId}/ask-query` : `/vendor/logistic-dashboard/${logisticDraftId}/ask-query`)}
        >
          Ask A Query
        </Button>
      </div>

      <Typography variant="h4">Your Queries</Typography>
      <Box className="dashboard-container" px={10} py={7}>
        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "20px" }}>Title</th>
              <th>Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan={3}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  Loading...
                </td>
              </tr>
            ) : queries.length > 0 ? (
              queries.map((query, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  <td style={{ padding: "20px" }}>{query.title}</td>
                  <td>{formatDateTime(query.createdDate)}</td>
                  <td>{query.status}</td>
                  <td>
                    <Button
                      className="btn-outlined"
                      sx={{ margin: "0 !important", width: "auto !important" }}
                      onClick={() => handleOpen(query)}
                    >
                      View
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No rows
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Box>

      <Box className="btn-container">
        <Button
          className="btn-outlined"
          onClick={() => navigate(`/vendor/dashboard/${rfqId}`)}
        >
          Back
        </Button>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2} textAlign={"center"}>
            Query Details
          </Typography>
          <Typography variant="subtitle1">
            <strong>Title:</strong> {selectedQuery?.title}
          </Typography>
          <Typography variant="subtitle1" mt={2}>
            <strong>Body:</strong>
          </Typography>
          <Typography variant="body1" mb={2}>
            {selectedQuery?.body}
          </Typography>
          <Typography variant="subtitle1">
            <strong>Answer:</strong>
          </Typography>
          <Typography variant="body1">
            {selectedQuery?.answer || "No answer yet."}
          </Typography>
          <Box className="btn-container">
            <Button className="btn-contained" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ViewQueries;
